/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { randomGetAnswerbookAsk } from "../../funcs/randomGetAnswerbookAsk.js";
import { GetAnswerbookAskRequest$zodSchema } from "../../models/getanswerbookaskop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetAnswerbookAskRequest$zodSchema,
};

export const tool$randomGetAnswerbookAsk: ToolDefinition<typeof args> = {
  name: "random-get-answerbook-ask",
  description: `答案之书

想要获得人生问题的神秘答案吗？答案之书API提供了一个神奇8球风格的问答服务，你可以提问并获得随机的神秘答案。

## 功能概述
通过向答案之书提问，你将获得一个充满智慧（或许）的随机答案。这个API支持通过查询参数或POST请求体两种方式提问。

## 使用须知

> [!TIP]
> **提问技巧**
> - 提出明确的问题会获得更好的体验
> - 问题不能为空
> - 支持中文问题
> - 答案具有随机性，仅供娱乐参考`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await randomGetAnswerbookAsk(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
